<template>
  <div id="app" class="animated fadeIn" :class="'app' + languageType">
    <Header v-if="languageType == 'cn'"></Header>
    <Headeren v-else-if="languageType == 'en'"></Headeren>
    <Headerjp v-else></Headerjp>
    <router-view />
    <Footer v-if="languageType == 'cn'"></Footer>
    <Footeren v-else-if="languageType == 'en'"></Footeren>
    <Footerjp v-else></Footerjp>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "App",
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      languageType: state => state.languageType
    })
  },
  watch: {
    $route(to, from) {
      if (to.meta.type === 'en') {
        this.$store.commit("changeLan", 'en');
      } else if (to.meta.type === 'jp') {
        this.$store.commit("changeLan", 'jp');
      } else {
        this.$store.commit("changeLan", 'cn');
      }
    },
  },
  mounted() {
    //this.languageType = this.$store.state.languageType;
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: SourceHanSansCN-Regular;
  opacity: 0;
  animation-delay: .5s;

  &.appen {
    font-family: $FM6;
  }

  &.appjp {
    font-family: $KM;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue